/**
 *
 * Module:        Library
 * Name:          Guru Export Source
 * Description:   Selects the last substantive Guru answer for repeatable PDF and Excel exports
 * Developers:    Adrian Engelmann, Kiran Jayaramu, Nicu Bratescu
 * Copyright:     Copyright 2026 by Qalgo GmbH (www.qalgo.de). All rights reserved.
 *
 */

const isCompletedExportMessage = message => Boolean(
	message && (message.guruExportCompleted || message.guruPdfDownload || message.guruExcelDownload ||
		/\{Guru(?:Pdf|Excel)\|[^{}]*\}/i.test(String(message.content || '')))
);

const isExportMetaMessage = message => Boolean(
	message && (message.guruExportEligible === false || message.guruExportPrepared ||
		isCompletedExportMessage(message))
);

const precedingQuestion = (messages, assistantIndex) => {
	for (let index = assistantIndex - 1; index >= 0; index -= 1) {
		const message = messages[index];
		if (message && message.self && !message.deletedAt) {
			return String(message.prompt || message.content || '');
		}
	}
	return '';
};

export const findGuruExportSource = (messages, beforeIndex) => {
	const sourceMessages = Array.isArray(messages) ? messages : [];
	const end = Number.isInteger(beforeIndex)
		? Math.min(beforeIndex, sourceMessages.length)
		: sourceMessages.length;
	let skipLegacyPreparation = false;
	for (let index = end - 1; index >= 0; index -= 1) {
		const message = sourceMessages[index];
		if (!message || message.self || message.deletedAt ||
			typeof message.content !== 'string' || !message.content.trim()) continue;
		if (isCompletedExportMessage(message)) {
			skipLegacyPreparation = true;
			continue;
		}
		if (message.guruExportPrepared || message.guruExportEligible === false) {
			if (message.guruExportPrepared) skipLegacyPreparation = false;
			continue;
		}
		// Chats written before the explicit metadata existed contain the sequence
		// substantive answer -> preparation -> confirmation -> completed export.
		// After skipping that completed export, skip exactly the adjacent assistant
		// preparation as well. This is structural and therefore language-independent.
		if (skipLegacyPreparation) {
			skipLegacyPreparation = false;
			continue;
		}
		if (isExportMetaMessage(message)) continue;
		return {
			question: precedingQuestion(sourceMessages, index),
			answer: String(message.content || ''),
			sources: Array.isArray(message.sources) ? message.sources.slice(0, 8) : []
		};
	}
	return null;
};

